// extracted by mini-css-extract-plugin
module.exports = {"globalFooter":"globalFooter___1B1Jn","links":"links___2dAXp","copyright":"copyright___2gPEL","version":"version___kGuGV"};